import Request from '~/providers/Request';

const fetchAllCidIds = async (input, page, resolve) => {
   
  await Request.get('/admin/cids', {
    sorter: 'name.asc',
    qs: input,
    page: page,
    perPage: 50,
  }).then((resp) => {
    const items = resp.data.map((e) => ({
      id: Number(e.id),
      name: `${e?.cid} - ${e?.description}`,
      external_id: e?.cid,
    }));
    resolve({
      total_count: resp.meta.total,
      items: [
        ...items
      ]
    });
  });
};

export default fetchAllCidIds;
